import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

const initializeFormPopups = () => {
  try {
    const modalContainer = document.createElement("div");
    modalContainer.innerHTML = `
      <div class="modal fade" id="formModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content rounded-5 p-4">
            <div class="modal-header border-0">
              <div class="modal-title d-block"></div>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body widget-careers">
              <div class="form-wrapper application-form bg-transparent border-0"></div>
            </div>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(modalContainer);

    const bootstrapModal = new bootstrap.Modal(document.getElementById("formModal"));

    document.querySelectorAll(".modal-form-init").forEach(el => {
      el.addEventListener("click", () => {
        const formId = el.getAttribute("data-form-id");
        const headerContent = el.getAttribute("data-form-header") || "";

        // Move partial form into modal
        const partialForm = document.querySelector(`.partial-form[data-form-id="${formId}"]`);
        const modalWrapper = document.querySelector("#formModal .form-wrapper");
        const modalHeader = document.querySelector("#formModal .modal-title");

        if (partialForm && modalWrapper) {
          modalWrapper.innerHTML = ""; // clear previous form
          modalWrapper.appendChild(partialForm); // move into modal
          modalWrapper.setAttribute("data-form-id", formId);
        }

        if(modalHeader) {
          modalHeader.innerHTML = headerContent;
        }
        // Show modal
        bootstrapModal.show();

        // Prefill values
        if (typeof PrefillFormValues === "function") {
          PrefillFormValues();
        }

        // On close, move form back
        const modalEl = document.getElementById("formModal");
        modalEl.addEventListener("hidden.bs.modal", () => {
          const placeholder = document.querySelector(`.partial-form-${formId}`);
          if (placeholder && partialForm) {
            placeholder.appendChild(partialForm);
          }
        }, { once: true });
      });
    });
  } catch (error) {
    console.error("Error initializing handling of popup forms:", error);
  }
};

export { initializeFormPopups };
